import api from "./api";
import {iniciarRequisicao, logout} from "../helpers";
import {STATUS_HTTP} from "./statusHTTP";

export const getListaFornecedoresFull = async (parametros) => {
  let url = `/get_lista_fornecedores_full`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.fornecedores;
}

export const getListaCompradoresFull = async (parametros) => {
  let url = `/get_lista_compradores_full`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.compradores;
}

export const editarCompradorMultipoFornecedor = async (parametros) => {
  let url = `/editar_comprador_multipo_fornecedor`;

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return;
}
class FornecedorAPI {
  async editarParametrosFornecedor(headers, params) {
    const response = await api({
      method: 'post',
      url: '/editar_parametros_fornecedor',
      headers,
      data: params
    });
    return response;
  }

  async setUltimaAnaliseFornecedor(headers, params) {
    const response = await api({
      method: 'post',
      url: '/compras_ultima_analise_fornecedor',
      headers,
      data: params
    });
    return response;
  }

  async getFornecedores(headers, params = {}) {
    return await api.get("/fornecedor", { params, headers });
  }

  async getFornecedoresEmProdutoFilial(headers, params = {}) {
    return await api.get("/fornecedor/produto", { params, headers });
  }

  async buscarMovimentacoesDepartamento(grupo, filial, departamento) {
    let url = `departamentos/${departamento}/compras/grupos/${grupo}/filiais/${filial}/indicador-movimentacoes`;

    const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(() => logout());

    if (status === STATUS_HTTP.OK) {
      localStorage.token = data.token;
      return data.movimentacoes;
    }

    logout();
  }

  async criarGrupoAnaliseCompra(params) {
    const headers = iniciarRequisicao();
    const config = {
      method: 'post',
      url: '/fornecedores/grupo-analise',
      headers,
      data: params
    };

    return await api(config);
  }

  async editarGrupoAnaliseCompra(params) {
    const headers = iniciarRequisicao();
    const config = {
      method: 'put',
      url: `/fornecedores/grupo-analise/${params.id}`,
      headers,
      data: params
    };

    return await api(config);
  }

  async excluirGrupoAnaliseCompra(params) {
    const headers = iniciarRequisicao();
    const config = {
      method: 'delete',
      url: `/fornecedores/grupo-analise/${params.id}`,
      headers,
      data: params
    };

    return await api(config);
  }

  async buscarGrupoAnalise(id) {
    const headers = iniciarRequisicao();
    return await api.get(`/fornecedores/grupo-analise/${id}`, { headers });
  }

  async getFornecedorSilenciar(headers, params) {
    return await api({
      method: 'post',
      url: '/silenciar_fornecedor',
      headers,
      data: params
    })
  }

  async getFornecedoresProdutosSilenciados(headers, params) {
    const response = await api.get("/fornecedor/produtos-silenciados", { headers, params });
    return response;
  }
}

export default new FornecedorAPI();
